let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gBdVF")).then(() => parcelRequire('1gEOj'));